module.exports = {
  PROCESSING_STARTED: 0,
  AUDIO_EXTRACTION_SUCCEEDED: 1,
  PROCESSING_SUCCEEDED: 2,
  PROCESSING_FAILED: 3,
  PROCESSING_NOT_STARTED: 4,
  UPLOADED_BEFORE_TRANSCRIPTION: 5,
};
